import { render, staticRenderFns } from "./newAuditoriumEdition.vue?vue&type=template&id=1b81cde0"
import script from "./newAuditoriumEdition.vue?vue&type=script&lang=js"
export * from "./newAuditoriumEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports